import React from 'react';
import HubPage from '../../ui-components/HubPage';

const ITEM_META = {
  '/offertes': { icon: 'handshake', desc: 'Offertes opstellen met AI — van mail of meeting tot concept in Gripp, met AI-check' },
  '/strategy': { icon: 'flag', desc: 'Strategisch dashboard — koers, pijlers en voortgang' },
  '/opdracht-mix': { icon: 'pie_chart', desc: 'Verdeling van opdrachten per type en dienst — inzicht in de portfolio-mix' },
  '/joris-dashboard': { icon: 'insights', desc: 'Projecten en werkdruk per PL, draaidagen van regie en camera, uren van uitvoerders' },
  '/declarabiliteit': { icon: 'percent', desc: 'Uren binnen budget ÷ beschikbare uren, per medewerker per maand' },
  '/sales-dashboard': { icon: 'trending_up', desc: 'Omzet, pipeline en klantoverzicht' },
  '/sales/prospects': { icon: 'handshake', desc: 'Prospect-CRM voor sales-team met AI-tips' },
  '/revenue-forecast': { icon: 'show_chart', desc: 'Omzetprognose per maand en projectleider' },
  '/bbi-doel': { icon: 'flag', desc: 'Brutobijdrage tegenover het bonusdoel, met presentatie-sheet' },
  '/ohw-check': { icon: 'fact_check', desc: 'Onderhanden werk controle per project' },
  '/uren-check': { icon: 'schedule', desc: 'Urenoverzicht en controle per medewerker' },
  '/enquete-dashboard': { icon: 'star', desc: 'Enquête resultaten en tevredenheidsscores' },
};

export default function OperationsHub() {
  return (
    <HubPage
      sectionKey="operations"
      subtitle="Management dashboards en controle"
      headerIcon="show_chart"
      headerAccent={{ color: '#635983', bg: '#dbcdff' }}
      itemMeta={ITEM_META}
    />
  );
}
